// Registraciya service worker + detektsiya obnovleniya (bez zavisimostey).
// onNeedRefresh(registration) — vyzyvaetsya kogda gotov novyy SW i zhdyot aktivacii.
export function registerSW(onNeedRefresh) {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  // Posle skipWaiting novyy SW beryot kontrol → perezagruzhaem stranicu odin raz.
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('/sw.js');

      // Uzhe est SW v ozhidanii (obnovilis mezhdu sessiyami).
      if (reg.waiting && navigator.serviceWorker.controller) onNeedRefresh(reg);

      reg.addEventListener('updatefound', () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener('statechange', () => {
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            onNeedRefresh(reg);
          }
        });
      });

      // Periodicheski proveryaem obnovlenie, poka vkladka otkryta.
      setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
    } catch {
      /* SW ne kritichen — app rabotaet i bez nego */
    }
  });
}

// Primenit obnovlenie: prosim zhdushiy SW aktivirovatsya (dalshe controllerchange → reload).
export function applyUpdate(reg) {
  if (reg?.waiting) reg.waiting.postMessage('SKIP_WAITING');
}
